import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import isExternalUrl from 'helpers/isExternalUrl'

import { TicketIcon } from '@pleio/icons/ticket'

import IconButton from 'js/components/IconButton'

const ViewTicketLink = ({ entity }) => {
    const { t } = useTranslation()

    const { ticketLink } = entity

    const isExternal = isExternalUrl(ticketLink)

    const sharedProps = {
        variant: 'primary' as const,
        className: 'EventActionButton',
        radiusStyle: 'rounded' as const,
        'aria-label': `${t('entity-event.ticket')} ${
            isExternal ? t('global.opens-in-new-window') : ''
        }`,
        children: (
            <>
                <TicketIcon />
                {t('entity-event.ticket')}
            </>
        ),
    }

    return (
        <div className="EventAction">
            {isExternal ? (
                <IconButton
                    {...sharedProps}
                    as="a"
                    href={ticketLink}
                    target="_blank"
                    rel="noopener noreferrer"
                />
            ) : (
                <IconButton {...sharedProps} as={Link} to={ticketLink} />
            )}
        </div>
    )
}

export default ViewTicketLink
